import React from 'react';
import CreatableSelect from 'react-select/creatable';
import {
  getIndianStates,
  getCountries,
  getDistrictOptions,
  DEFAULT_COUNTRY,
  DEFAULT_STATE,
} from '../utils/PicklistProvider';

export const ADDRESS_DEFAULTS = {
  country: DEFAULT_COUNTRY,
  state: DEFAULT_STATE,
  district: '',
};

const creatableStyles = {
  control: (base) => ({
    ...base,
    minHeight: 38,
    backgroundColor: '#ffffff',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#212529',
  }),
  input: (base) => ({
    ...base,
    color: '#212529',
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#ffffff',
    zIndex: 20,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? '#EEF7FC' : '#ffffff',
    color: '#212529',
  }),
};

function AddressLocationFields({
  values = {},
  onChange,
  onFieldChange,
  error = {},
  requiredState = true,
  idPrefix = '',
  classNameLabel = 'form-group col-sm-4 text-right',
  classNameInput = 'form-control col-sm-7',
  selectClassName,
}) {
  const country = values.country ?? DEFAULT_COUNTRY;
  const state = values.state ?? '';
  const district = values.district ?? '';

  const emitChange = (name, value) => {
    if (typeof onChange === 'function') {
      onChange(name, value);
    } else if (typeof onFieldChange === 'function') {
      onFieldChange({ target: { name, value } });
    }
  };

  const handleNativeChange = (event) => {
    emitChange(event.target.name, event.target.value);
  };

  const districtOptions = getDistrictOptions(state).map((d) => ({
    label: d.name,
    value: d.value,
  }));

  const districtValue = district
    ? { label: district, value: district }
    : null;

  const stateSelectClass =
    selectClassName ||
    `browser-default custom-select ${classNameInput}${requiredState ? ' mandatory-form-control' : ''}`;
  const countrySelectClass =
    selectClassName || `browser-default custom-select ${classNameInput}`;

  return (
    <>
      <label htmlFor={`${idPrefix}country`} className={classNameLabel}>Country</label>
      <select
        id={`${idPrefix}country`}
        name="country"
        className={countrySelectClass}
        onChange={handleNativeChange}
        value={country || ''}
      >
        {getCountries().map((c) => (
          <option key={c.value} value={c.value}>{c.name}</option>
        ))}
      </select>
      <br />
      {error.country && (
        <>
          <strong className="form-group col-sm-12 text-center text-danger">{error.country}</strong>
          <br />
        </>
      )}

      <label htmlFor={`${idPrefix}state`} className={classNameLabel}>State</label>
      <select
        id={`${idPrefix}state`}
        name="state"
        className={stateSelectClass}
        required={requiredState}
        onChange={handleNativeChange}
        value={state || ''}
      >
        <option value="">Select State</option>
        {getIndianStates().map((indian_state) => (
          <option key={indian_state.value} value={indian_state.value}>
            {indian_state.name}
          </option>
        ))}
      </select>
      <br />
      {error.state && (
        <>
          <strong className="form-group col-sm-12 text-center text-danger">{error.state}</strong>
          <br />
        </>
      )}

      <label htmlFor={`${idPrefix}district`} className={classNameLabel}>District</label>
      <div className={classNameInput.includes('col-sm-7') ? 'col-sm-7' : undefined} style={{ paddingLeft: 0, paddingRight: 0 }}>
        <CreatableSelect
          inputId={`${idPrefix}district`}
          name="district"
          className="react-select-dropdown"
          styles={creatableStyles}
          isClearable
          isSearchable
          options={districtOptions}
          value={districtValue}
          placeholder="Select or type district"
          formatCreateLabel={(input) => `Use "${input}"`}
          noOptionsMessage={({ inputValue }) =>
            inputValue
              ? `No match — press enter to use "${inputValue}"`
              : (districtOptions.length
                ? 'Type to filter districts'
                : 'Type a district name')
          }
          onChange={(option) => {
            emitChange('district', option ? option.value : '');
          }}
        />
      </div>
      <br />
      {error.district && (
        <>
          <strong className="form-group col-sm-12 text-center text-danger">{error.district}</strong>
          <br />
        </>
      )}
    </>
  );
}

export default AddressLocationFields;
